//#region Styles
import { Row } from "components/styles";
//#endregion
//#region Components
import DataHeaderDetail from "components/DataHeaderDetail/DataHeaderDetail";
//#endregion
//#region Icons
import FileIcon2 from "icons/FileIcon2";
import UserIcon from "icons/UserIcon";
//#endregion

const HeaderDetail = ({
    title, speaker    
}) => {
    const { free, search } = speaker;
    return (
        <Row justifyContent="flex-start" gap="8px">
            <DataHeaderDetail 
                text={title}
                icon={<FileIcon2/>}/>
            <DataHeaderDetail 
                text={`Ponente / Docente: ${free?.fullName || search?.fullName || "-"}`}
                icon={<UserIcon/>}/>
        </Row>
    );
}

export default HeaderDetail;